import { fetcher } from "@areahub/adapters";
import useSWR from "swr";

/**
 * A custom hook to fetch a resource from the `/resource` API route.
 *
 * @param {string} slug - The unique identifier for the resource.
 * @returns An object containing:
 *   - `resource`: The fetched resource data, which includes content describing the resource and form fields for users to complete.
 *   - `loading`: A boolean indicating whether the data is still being fetched.
 *
 * The fetched resource contains information that allows users to submit a form and receive an email with the downloadable resource PDF.
 *
 */
export default function useResourceFetcher(slug: string) {
  const { data, isValidating } = useSWR<any>(`/api/resource/${slug}`, fetcher);

  return { resource: data, loading: !data && isValidating };
}
